import { memo } from "react";

import { bookmarkColors } from "utils/colors";

import { ListItemButton, Stack } from "@mui/material";

const ColorBox = ({ handler, bookmarkColor }) => {
  return (
    <Stack
      direction="row"
      sx={{
        p: "1em 2em",
        flexWrap: "wrap",
        gap: "0.5em",
        pb: "2em",
        justifyContent: "center",
        bgcolor: "background.default",
      }}
    >
      {bookmarkColors.map((color) => {
        return (
          <ListItemButton
            key={color}
            sx={{
              height: 35,
              width: 35,
              flexGrow: 0,
              bgcolor: color,
              cursor: "pointer",
              "&:hover": {
                backgroundColor: `${color}aa`,
                border: "1px solid",
              },
              "&.Mui-selected, &.Mui-selected:hover": {
                borderRadius: "50%",
                backgroundColor: color,
              },
            }}
            onClick={() => handler(color)}
            selected={bookmarkColor === color}
            aria-label="Bookmark color"
          />
        );
      })}
    </Stack>
  );
};
export default memo(ColorBox);
